import React, { useEffect, useState } from 'react';
import { useTrades } from './shared/useTrades';
import { CoinRegistryProvider } from './shared/CoinRegistryContext';
import { AuthProvider, useAuth } from './auth/AuthContext';
import LoginPage from './auth/LoginPage';
import HomeTab from './tabs/HomeTab/HomeTab';
import SettingsTab from './tabs/SettingsTab/SettingsTab';
import './App.css';

type TopTab = 'Home' | 'Settings';

function Dashboard() {
  const { session, logout } = useAuth();
  const { trades, deleteTrade, editTrade } = useTrades();

  const tabs: TopTab[] = ['Home', 'Settings'];
  const [activeTab, setActiveTab] = useState<TopTab>('Home');

  // If the role changes (e.g. logout/login as another user) and the active tab
  // is no longer available, fall back to the first allowed tab.
  useEffect(() => {
    if (!tabs.includes(activeTab)) setActiveTab(tabs[0]);
  }, [tabs, activeTab]);

  if (!session) return <LoginPage />;

  return (
    <CoinRegistryProvider>
      <div className="app">
        <header className="app-header">
          <h1>Trading Dashboard</h1>
          <div className="app-user">
            <span className="app-user-name">{session.username}</span>
            <span className={`app-role-badge ${session.role}`}>
              {session.role}
            </span>
            <button className="app-logout" onClick={logout}>
              Logout
            </button>
          </div>
        </header>

        <nav className="tab-bar">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </nav>

        <main className="tab-content">
          {activeTab === 'Home' && (
            <HomeTab trades={trades} onEdit={editTrade} />
          )}
          {activeTab === 'Settings' && (
            <SettingsTab trades={trades} onDelete={deleteTrade} />
          )}
        </main>
      </div>
    </CoinRegistryProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Dashboard />
    </AuthProvider>
  );
}
